class SwaglabMobileMenu extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.tabs = Array.from(this.querySelectorAll('[data-mobile-menu-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-mobile-menu-panel]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activateTab(tab.dataset.mobileMenuTab, true));
      tab.addEventListener('keydown', (event) => this.handleTabKeydown(event));
    });
  }

  activateTab(tabName, focusTab = false) {
    if (!tabName) return;

    this.resetSubmenus();

    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.mobileMenuTab === tabName;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
      if (isActive && focusTab) tab.focus();
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.mobileMenuPanel !== tabName;
    });
  }

  handleTabKeydown(event) {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();

    const currentIndex = this.tabs.indexOf(event.currentTarget);
    let nextIndex = currentIndex;

    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;

    this.activateTab(this.tabs[nextIndex]?.dataset.mobileMenuTab, true);
  }

  resetSubmenus() {
    this.querySelectorAll('details[open], details.menu-open').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-open');
      details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
    });

    this.closest('.menu-drawer')?.classList.remove('menu-drawer--has-submenu-opened');
  }
}

if (!customElements.get('swaglab-mobile-menu')) {
  customElements.define('swaglab-mobile-menu', SwaglabMobileMenu);
}
